import { useState } from 'react';
import type { FormEvent } from 'react';

export interface BlogWritingFormValues {
  title: string;
  keyword: string;
}

interface BlogWritingFormProps {
  defaultTitle?: string;
  defaultKeyword?: string;
  isLoading?: boolean;
  onSubmit: (values: BlogWritingFormValues) => void;
}

export const BlogWritingForm = ({
  defaultTitle = '',
  defaultKeyword = '',
  isLoading = false,
  onSubmit,
}: BlogWritingFormProps) => {
  const [title, setTitle] = useState(defaultTitle);
  const [keyword, setKeyword] = useState(defaultKeyword);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!title.trim() || !keyword.trim()) {
      return;
    }

    onSubmit({
      title: title.trim(),
      keyword: keyword.trim(),
    });
  };

  return (
    <form className="search-form" onSubmit={handleSubmit}>
      <div className="search-form__row">
        <label className="search-form__label" htmlFor="title-input">
          제목
        </label>
        <input
          id="title-input"
          className="search-form__input"
          type="text"
          placeholder="예: 디지털 노마드로 성공하는 방법"
          value={title}
          onChange={(event) => setTitle(event.target.value)}
          disabled={isLoading}
        />
      </div>

      <div className="search-form__row">
        <label className="search-form__label" htmlFor="keyword-input">
          키워드
        </label>
        <input
          id="keyword-input"
          className="search-form__input"
          type="text"
          placeholder="예: 디지털 노마드"
          value={keyword}
          onChange={(event) => setKeyword(event.target.value)}
          disabled={isLoading}
        />
      </div>

      <div className="search-form__actions">
        <button className="search-form__submit" type="submit" disabled={isLoading}>
          {isLoading ? '글 작성 중…' : '✍️ 글 작성'}
        </button>
        <button
          className="search-form__secondary"
          type="button"
          disabled={isLoading}
          style={{
            marginLeft: '12px',
            padding: '12px 20px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
            transition: 'all 0.2s'
          }}
          onClick={() => alert('AI 이미지 생성 기능은 준비 중입니다.')}
        >
          🎨 AI 이미지 생성
        </button>
        <button
          className="search-form__secondary"
          type="button"
          disabled={isLoading}
          style={{
            marginLeft: '12px',
            padding: '12px 20px',
            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            boxShadow: '0 2px 8px rgba(240, 147, 251, 0.3)',
            transition: 'all 0.2s'
          }}
          onClick={() => alert('SVG 생성 기능은 준비 중입니다.')}
        >
          📐 SVG 생성
        </button>
      </div>
    </form>
  );
};
